import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import matterSlice from '../app/modules/apps/matters/matterSlice'
import currentUserSlice from '../app/modules/accounts/currentUserSlice'

const store = configureStore({
  reducer: {
    matterMDL: matterSlice,
    currentUserMDL: currentUserSlice
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch

export default store